import { render, staticRenderFns } from "./BSTableNoData.vue?vue&type=template&id=00468cc7&scoped=true"
import script from "./BSTableNoData.vue?vue&type=script&lang=js"
export * from "./BSTableNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00468cc7",
  null
  
)

export default component.exports